import { clientInstance } from "../config/config";

export let createFlashcardAPI = async (flashcardData) => {
    return clientInstance.post(`/flashcard`, flashcardData);
}

export let getFlashcardAPI = async (flashcardId) => {
    return clientInstance.get(`/flashcard/${flashcardId}`);
}

export let getMyFlashcardsAPI = async () => {
    return clientInstance.get(`/flashcard/my`);
}

export let getStudentFlashcardsAPI = async () => {
    return clientInstance.get(`/flashcard/student`);
}

export let updateFlashcardAPI = async (flashcardId, flashcardData) => {
    return clientInstance.put(`/flashcard/${flashcardId}`, flashcardData);
}

export let deleteFlashcardAPI = async (flashcardId) => {
    return clientInstance.delete(`/flashcard/${flashcardId}`);
}

export let assignFlashcardAPI = async (flashcardId, studentId) => {
    return clientInstance.post(`/flashcard/${flashcardId}/assign`, { studentId });
}

